if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get select() {
        return this.querySelector('select');
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();
        
        this.optionChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        
        const skioPlanPicker = this.mainProductInfo?.querySelector('skio-plan-picker');
        if (skioPlanPicker) {
          this.syncInitialSellingPlan();
          
          skioPlanPicker.addEventListener('skio::update-selling-plan', (event) => {
            const { sellingPlan, formattedPrice } = event.detail || {};
            this.updateSellingPlanAndPrice(sellingPlan, formattedPrice);
          });
        }

        this.init();
        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }

      updateQuantityInput() {
        const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('#product-form-sticky-atc-bar');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      disconnectedCallback() {
        if (this.optionChangeUnsubscriber) {
          this.optionChangeUnsubscriber();
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        let displayPrice = this.currentVariant.price;
        let displayCompareAtPrice = this.currentVariant.compare_at_price;
        // On sale.
        if (displayCompareAtPrice && displayCompareAtPrice > displayPrice) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(displayPrice, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && displayCompareAtPrice && displayCompareAtPrice > displayPrice) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(displayCompareAtPrice, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(displayPrice, moneyFormat)));
        }
        const productPriceContainer = this.container?.querySelector('.product-price-container');
        if (productPriceContainer) {
          productPriceContainer.textContent = FoxTheme.Currency.formatMoney(displayPrice, moneyFormat);
        }

        const { unit_price_measurement } = this.currentVariant;
        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncInitialSellingPlan() {
          const skioPlanPicker = this.mainProductInfo?.querySelector('skio-plan-picker');
          if (!skioPlanPicker) return;
          const mainSellingPlanInput = skioPlanPicker.querySelector('input[name="selling_plan"]');
          const sellingPlanId = mainSellingPlanInput?.value;
          
          const skioPriceElement = skioPlanPicker.querySelector('.skio-price.selling-plan-price');
          const formattedPrice = skioPriceElement?.textContent?.trim();
          
          if (sellingPlanId || formattedPrice) {
            const stickySellingPlanInput = this.productForm?.querySelector('[name="selling_plan"]');
            
            if (sellingPlanId && stickySellingPlanInput) {
              stickySellingPlanInput.value = sellingPlanId;
            }
            
            if (formattedPrice) {
              this.updatePriceDisplay(formattedPrice);
            } 
            else {
              const mainSubmitButton = this.mainProductInfo?.querySelector('[id^="ProductSubmitButton-"]');
              const priceElement = mainSubmitButton?.querySelector('.price-add-to-bag, .subscription-price');
              if (priceElement?.textContent?.trim()) {
                this.updatePriceDisplay(priceElement.textContent.trim());
              }
            }
          }
          console.log('syncInitialSellingPlan', sellingPlanId, formattedPrice);
      }

      updateSellingPlanAndPrice(sellingPlan, formattedPrice) {
        const stickySellingPlanInput = this.productForm?.querySelector('[name="selling_plan"]');
        
        if (stickySellingPlanInput) {
          if (sellingPlan?.id) {
            stickySellingPlanInput.value = sellingPlan.id;
          } else {
            stickySellingPlanInput.value = '';
          }
        }
        
        if (formattedPrice) {
          this.updatePriceDisplay(formattedPrice);
        }
      }

      updatePriceDisplay(formattedPrice) {
        const productPriceContainer = this.container?.querySelector('.product-price-container');
        if (productPriceContainer) {
          productPriceContainer.textContent = formattedPrice;
        }
        
        const selectors = {
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
        };
        const { salePrice, compareAtPrice } = FoxTheme.utils.queryDomNodes(selectors, this);
        
        if (salePrice) {
          salePrice.innerHTML = formattedPrice;
        }
        if (compareAtPrice && compareAtPrice.length) {
          compareAtPrice.forEach((item) => {
            item.innerHTML = formattedPrice;
          });
        }
      }

      handleOptionValueChange({ data: { event } }) {
        if (!this.mainProductInfo || !this.mainProductInfo.contains(event.target)) return;
        this.syncFromMainForm();
      }

      syncFromMainForm() {
        const mainSubmitButton = this.mainProductInfo?.querySelector('[id^="ProductSubmitButton-"]');
        if (!mainSubmitButton) return;

        const mainForm = mainSubmitButton.closest('form[is="product-form"]') || 
                        this.mainProductInfo?.querySelector('form[is="product-form"]');
        if (!mainForm) return;

        const mainVariantInput = mainForm.querySelector('[name="id"]');
        const mainQuantityInput = mainForm.querySelector('[name="quantity"]');
        
        if (!mainVariantInput) return;

        const mainVariantId = mainVariantInput.value;
        const variantSelect = this.select;
        
        if (variantSelect) {
          const wasDifferent = variantSelect.value !== mainVariantId;
          
          this.isUpdating = true;
          
          variantSelect.value = mainVariantId;
          
          const option = variantSelect.querySelector(`option[value="${mainVariantId}"]`);
          if (option) {
            variantSelect.querySelectorAll('option').forEach(opt => opt.removeAttribute('selected'));
            option.setAttribute('selected', 'selected');
          }
          
          this.isUpdating = false;
          
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(mainVariantId));
          
          if (wasDifferent && this.currentVariant) {
            this.updateQuantityInput();
          }
        }

        if (mainQuantityInput) {
          const stickyQuantityInput = this.productForm?.querySelector('[name="quantity"]');
          if (stickyQuantityInput && stickyQuantityInput.value !== mainQuantityInput.value) {
            stickyQuantityInput.value = mainQuantityInput.value;
          }
        }

        const isDisabled = mainSubmitButton.hasAttribute('disabled') || 
                          mainSubmitButton.getAttribute('aria-disabled') === 'true';
        const buttonText = mainSubmitButton.textContent.trim();
        const isSoldOut = buttonText.toLowerCase().includes('sold out');
        
        if (this.currentVariant) {
          this.updateButton(isDisabled || isSoldOut, isSoldOut ? FoxTheme.variantStrings.soldOut : '');
        } else if (variantInput) {
          this.updateButton(isDisabled || isSoldOut, isSoldOut ? FoxTheme.variantStrings.soldOut : '');
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          this.syncFromMainForm();
          
        });
      }
    }
  );
}
